import { Link } from "react-router-dom";
import React from "react";

interface HeaderProps {
  heading: React.ReactNode;
  paragraph: React.ReactNode;
  linkName: string;
  linkUrl: string | null;
  className?: string; // ✅ optional className
}

export default function Header({
  heading,
  paragraph,
  linkName,
  linkUrl,
  className = "mb-10", // ✅ default to mb-10
}: HeaderProps) {
  return (
    <div className={className}>
      <div className="flex justify-center">
        <img
          alt="Logo"
          className="h-14 w-14"
          src="https://ik.imagekit.io/pibjyepn7p9/Lilac_Navy_Simple_Line_Business_Logo_CGktk8RHK.png?ik-sdk-version=javascript-1.4.3&updatedAt=1649962071315"
        />
      </div>
      <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
        {heading}
      </h2>
      <div className="text-center text-sm text-gray-600 mt-5">
        {paragraph}{" "}
        <Link
          to={linkUrl ?? "#"}
          className="font-medium text-purple-600 hover:text-purple-500"
        >
          {linkName}
        </Link>
      </div>
    </div>
  );
}
